// Angular
import { Injectable } from '@angular/core';

// Environment
import { environment } from '@environments/environment';

// RxJs
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

// NgRx
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import {
  initUserState,
  getCurrentUserDetailsLoad,
  getCurrentUserDetailsSuccess,
  getCurrentUserDetailsError,
  getCurrentUserRolesLoad,
  getCurrentUserRolesSuccess,
  getCurrentUserRolesError,
} from '@core/state/user/user.actions';

// APIs
import {
  UsersClient,
  UserProfileViewModel,
  ModulesClient,
} from '@tech/api-clients/auth';

@Injectable()
export class UserEffects implements OnInitEffects {
  /**
   * Get Current User Details
   */
  getCurrentUserDetailsLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initUserState, getCurrentUserDetailsLoad),
      mergeMap(() =>
        this.usersClient.getCurrentUserProfile().pipe(
          map((user: UserProfileViewModel) =>
            getCurrentUserDetailsSuccess({ user })
          ),
          catchError((error) => of(getCurrentUserDetailsError({ error })))
        )
      )
    )
  );

  /**
   * Get Current User Roles
   */
  getCurrentUserRolesLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initUserState, getCurrentUserRolesLoad),
      mergeMap((props) =>
        this.modulesClient
          .getRolesForCurrentUserInModule(props.moduleCode)
          .pipe(
            map((roles: string[]) => getCurrentUserRolesSuccess({ roles })),
            catchError((error) => of(getCurrentUserRolesError({ error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private usersClient: UsersClient,
    private modulesClient: ModulesClient
  ) {}

  /**
   * This is started when the application is started
   */
  ngrxOnInitEffects(): Action {
    return initUserState({ moduleCode: environment.moduleCode });
  }
}
